export const dark = {
  primary: '#000',
  secondary: '#000',
  accent: '#000',
  error: '#000',
  warning: '#ff9800',
  info: '#d7e0dc',
  success: '#4caf50',
}
